import React from 'react';

const PolicyTermsPage = ({ title, content, isLast }) => {
  return (
    <div style={{ marginBottom: isLast ? '0' : '1.25rem' }}>
      <h2 style={{
        fontWeight: 600,
        fontSize: "1.25rem",
        marginBottom: "0.5rem",
        fontFamily:"Urbanist",
      }}>
        {title}
      </h2>
      {Array.isArray(content) ? (
        content.map((item, i) => (
          <p key={i} style={{ 
            marginBottom: "0.5rem", 
            lineHeight: "1.5", 
            fontSize: "1rem", 
            color: "#181C23", 
            fontWeight: "500" 
          }}>
            {item}
          </p>
        ))
      ) : (
        <p style={{ 
          marginBottom: "0.5rem", 
          lineHeight: "1.5", 
          fontSize: "1rem", 
          color: "#181C23", 
          fontWeight: "500" 
        }}>
          {content}
        </p>
      )}
    </div>
  );
};

export default PolicyTermsPage;